import React from "react"

import { ContentTag, connect } from "scrivito"

import { useProductObj } from "entities/products/model/useProductObj"

import {
  FollowUpConfigurationGroup,
  FollowUpConfigurationGroupProps
} from "./FollowUpConfigurationGroup"

type FollowUpConfigurationGroupConnectorProps = Omit<
  FollowUpConfigurationGroupProps,
  "productImage" | "productKind"
>

function FollowUpConfigurationGroupConnectorComponent({
  group,
  ...props
}: FollowUpConfigurationGroupConnectorProps) {
  const { productObj } = useProductObj(group.sourceProduct.productName)

  return (
    <FollowUpConfigurationGroup
      {...props}
      group={group}
      productImage={
        productObj ? (
          <ContentTag alt="" content={productObj} attribute="imageWidgets" />
        ) : undefined
      }
      productKind={productObj?.get("kind") || undefined}
    />
  )
}

export const FollowUpConfigurationGroupConnector = React.memo(
  connect(FollowUpConfigurationGroupConnectorComponent)
)
